module.exports = __webpack_public_path__ + "1d9f1c40d9c73a648913a22b3c503d10.gif";